import { render, staticRenderFns } from "./ExportFactorialMaterialModal.vue?vue&type=template&id=a28d5706&scoped=true"
import script from "./ExportFactorialMaterialModal.vue?vue&type=script&lang=js"
export * from "./ExportFactorialMaterialModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a28d5706",
  null
  
)

export default component.exports